// extracted by mini-css-extract-plugin
export default {"colabContainer":"editClients_colabContainer__6iJXU","heading":"editClients_heading__G1wU6","box":"editClients_box__O2VU7"};